import axios, { AxiosError, AxiosHeaders, AxiosRequestConfig } from 'axios';

import { fetchRetailerApiSettings } from '@ee-api/lookup-retailer-api/lookupRetailerApiService';
import type { BaseQueryFn } from '@reduxjs/toolkit/query';

export type AxiosBaseQueryFunction = BaseQueryFn<{
    url: string;
    method: AxiosRequestConfig['method'];
    data?: AxiosRequestConfig['data'];
    params?: AxiosRequestConfig['params'];
    isMultipartForm?: boolean;
}>;

export const axiosBaseQuery =
    (): AxiosBaseQueryFunction =>
    async ({ url, method, data, params, isMultipartForm }) => {
        // Determine the API host based on the current environment
        const apiLookup = await fetchRetailerApiSettings();

        const { apiHostname: baseUrl, token: bearerToken } = apiLookup;

        try {
            const headers = new AxiosHeaders();

            if (bearerToken) {
                headers.set('Authorization', `Bearer ${bearerToken}`);
            }

            if (!isMultipartForm) {
                // if it's not multi-part, then it's json
                // For multipart forms, let axios set the content-type automatically
                // This ensures the boundary is set correctly
                headers.set('Content-type', 'application/json');
            }

            const fullUrl = baseUrl + url;

            const result = await axios({
                url: fullUrl,
                method,
                data,
                params,
                headers,
            });

            return { data: result.data };
        } catch (err) {
            const axiosError = err as AxiosError;

            return {
                error: {
                    status: axiosError.response?.status,
                    data: axiosError.response?.data || null,
                    message: axiosError.message,
                },
            };
        }
    };
